

export class Util {
  static midpoint(coordinates: number[][]): number[] {
    let length = this.distance(coordinates);
    let currAlong = 0;
    let i = 0;
    let diff = 0;
    let dist = 0;
    while(i < coordinates.length - 1) {
      dist = this.distanceBetweenCoordinates(coordinates[i], coordinates[i+1]);
      if (currAlong + dist > length / 2) {
        diff = length / 2 - currAlong;
        break;
      } else {
        currAlong += dist;
      }
      i++;
    }
    let pointA = coordinates[i];
    let pointB = coordinates[i+1];

    return this.moveAlongLine([pointA, pointB], diff);
  }

  static moveAlongLine(line: number[][], moveAlong: number) {
    let pointA = line[0];
    let pointB = line[1];
    let dist = this.distanceBetweenCoordinates(pointA, pointB);

    let distX = pointB[0] - pointA[0];
    let resultX = pointA[0] + distX * moveAlong / dist;
    let distY = pointB[1] - pointA[1];
    let resultY = pointA[1] + distY * moveAlong / dist;
    
    return [resultX, resultY];
  }

  static findAngle(line: number[][]) {
    let pointA = line[0];
    let pointB = line[1];

    let angle = (Math.atan2(pointB[1] - pointA[1], pointB[0] - pointA[0]) * 180 / Math.PI);

    return angle;
  }

  static findAngleBetweenPoints(pointA: any, pointB: any) {
    let angle = (Math.atan2(pointB.y - pointA.y, pointB.x - pointA.x) * 180 / Math.PI);

    return angle;
  }

  static distance(coordinates: number[][]): number {
    let dist = 0;
    for(let i = 0; i < coordinates.length - 1; i++) {
      dist += this.distanceBetweenCoordinates(coordinates[i], coordinates[i+1]);
    }
    return dist;
  }

  static distanceBetweenCoordinates(pointA: number[], pointB: number[]): number {
    let diffX = pointA[0] - pointB[0];
    let diffY = pointA[1] - pointB[1];
    return Math.sqrt(diffX * diffX + diffY * diffY);
  }

  static findClosestSegment(point: number[], lines: number[][][]) {
    let minDist = 1000;
    let closestPoint = [0, 0];
    let nextPoint = [0, 0];
    for(let line of lines) {
      for(let i = 0; i < line.length; i++) {
        let currPoint = line[i];
        let currDist = this.distanceBetweenCoordinates(currPoint, point);
        if (currDist < minDist) {
          minDist = currDist;
          closestPoint = currPoint;
          if (i + 1 < line.length) {
            nextPoint = line[i + 1];
          } else {
            nextPoint = line[i - 1];
          }
        }
      }
    }

    return [closestPoint, nextPoint];
  }

  static findFurthestSegment(point: number[], lines: number[][][]) {
    let maxDist = -1;
    let furthestPoint = [0, 0];
    let nextPoint = [0, 0];
    for(let line of lines) {
      for(let i = 0; i < line.length; i++) {
        let currPoint = line[i];
        let currDist = this.distanceBetweenCoordinates(currPoint, point);
        if (currDist > maxDist) {
          maxDist = currDist;
          furthestPoint = currPoint;
          if (i + 1 < line.length) {
            nextPoint = line[i + 1];
          } else {
            nextPoint = line[i - 1];
          }
        }
      }
    }

    return [furthestPoint, nextPoint];
  }

  static findIcon(facilityType) {
    if (facilityType === 'PIPE') return 'pipeline';
    if (facilityType === 'STOR') return 'storage';
    if (facilityType === 'PROD') return 'powerplant';
    if (facilityType === 'GPG') return 'gpg';
    if (facilityType === 'COMPRESSOR') return 'compressor';
    if (['GATESTATION', 'LARGE', 'LNG'].includes(facilityType)) return 'gatestation';
    if (facilityType === 'HUB') return 'hub';
  }
}



// WEBPACK FOOTER //
// src/util.ts